import { Component, inject, Signal } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-custom-snackbar',
  standalone: false,

  templateUrl: './custom-snackbar.component.html',
  styleUrl: './custom-snackbar.component.scss',
})
export class CustomSnackbarComponent {
  data = inject<{ message: Signal<string> }>(MAT_SNACK_BAR_DATA);
  // Iniettiamo il riferimento alla snackbar attuale per poterla chiudere
  snackBarRef = inject(MatSnackBarRef<CustomSnackbarComponent>);
}
